import { lazyLoad } from 'utils/loadable';

export const PartnerSegmentPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerSegmentPage
);
